import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';

interface HighlightWrapperProps {
  children: React.ReactNode;
  highlight?: boolean;
  className?: string;
}

const HighlightWrapper: React.FC<HighlightWrapperProps> = ({ children, highlight, className }) => {
  return <Wrapper className={classNames(className, { highlight })}>{children}</Wrapper>;
};

export default HighlightWrapper;

const Wrapper = styled.div`
  background: transparent;
  border-radius: 8px;

  &.highlight {
    animation: highlightAnimation 1s ease-in-out 3;
  }

  @keyframes highlightAnimation {
    0% {
      box-shadow: unset;
    }
    50% {
      box-shadow: 0 0 20px 10px #d9b244;
    }
    100% {
      box-shadow: unset;
    }
  }
`;
